<br/>

<re-captcha (resolved)="resolved($event)"
            siteKey="6Lcm5_UjAAAAADFR-alP6RcMPcSjSy3XNOcNzjda"></re-captcha>